<template>
    <div>
        <modal name="list-actions" :scrollable="true" height="auto">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Selected shops</h5>
                <button type="button" class="close" @click="closeModal">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="panel-group">
                <div class="panel panel-warning" v-if="!this.cube && selectedShopsPart.offline.length > 0">
                    <div class="panel-heading">
                    <h5>
                        Offline
                        <small>we cannot perform some actions this time</small>
                    </h5>
                    </div>
                    <div class="panel-body">

                    <ul>
                        <li v-for="shop in selectedShopsPart.offline">{{shop.name}}</li>
                    </ul>

                    <!--<p>
                        <label for="afterboot" v-model="afterReboot">Perform action when they are back online <input type="checkbox" id="afterboot"></label>
                    </p>-->

                    </div>
                </div>

                <div class="panel panel-success" v-if="!this.cube">
                    <div class="panel-heading">
                    <h5>Online</h5>
                    </div>
                    <div class="panel-body">
                    <ul>
                        <li v-for="shop in selectedShopsPart.online">{{shop.name}}</li>
                    </ul>
                    </div>
                </div>

          <div class="panel actions">
            <div class="panel-body">
              <div class="run-action">
                <select v-model="selectedTask" class="form-control">
                  <option value="">SELECT ACTION</option>
                  <option v-for="action in tasks"  :value="action.task" v-if="actionVisible(action)" v-bind:key="action.name">{{action.name}}</option>
                </select>
              </div>

              <div v-if="selectedTask === 'registercube'" class="mt-3">
                  <h5> Select shop to re-register cube</h5>

                  <!-- <label class="label-input">
                    Branch: 
                    <input type="text" class="form-control" v-model="reinstall.context" placeholder="" disabled>
                  </label> -->

                  <div class="shop-select mb-3 mt-2">
                    <label class="label-input"> 
                      Shop: <br/>
                      <el-select
                        class="key-accounts"
                        v-model="selectedShop"
                        placeholder="Select shop"
                        popper-class="shopdropdown"
                        filterable 
                      >
                        <el-option
                          v-for="item in getShopList"
                          :key="item.id"
                          :value="item.id"
                          :label="item.name"
                        >
                          <span class="shop-name">{{ item.name }} </span>
                          <span class="shop-address">{{item.city}} </span>
                          <span class="shop-external-id"> externalID: {{ item.externalID }}</span>
                        </el-option>
                      </el-select>
                    </label>
                  </div>
              </div>

              <div v-if="selectedTask !== ''">
                <button type="button" class="btn btn-outline-secondary" @click="runAction()">{{selectedTaskButton(selectedTask)}}</button>
              </div>

                    <div v-if="tasksGenerated">
                      <a href="/#/Account?tab=updatetasks" class="btn btn-outline-secondary mt-3">Go to your tasks</a>
                    </div>

                    <div v-if="cube && false">
                        <ul>
                        <li>
                        <div class="input-group">
                            <div class="input-group-append">
                            <button type="button" class="btn btn-outline-secondary" @click="runAction('setScreen')">SetScreen</button>
                            </div>
                        </div>
                        </li>
                        <li>
                        <div class="input-group">
                            <input type="text" class="form-control" v-model="reinstall.context">
                            <select class="form-control" v-model="reinstall.environment">
                            <option v-for="env in enviroments" :value="env">{{env}}</option>
                            </select>
                            <div class="input-group-append">
                            <button type="button" class="btn btn-outline-secondary" @click="runAction('reinstall')">SET NEW CONTEXT</button>
                            </div>
                        </div>
                        </li>
                        </ul>
                    </div>
                    </div>
                </div>

                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" @click="closeModal">LEAVE</button>
            </div>
            </div>
        </modal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'ActionsModal',
    components: {
    },
    props: {
        selectedShops: {
            type: Array,
            default: function () {
                return [];
            }
        },
        cube: {
            type: Object,
            default: function () {
                return undefined;
            }
        },
        cubes: {
            type: Array,
            default: function () {
                return [];
            }
        },
        selectedShopsPart: {
            type: Object,
            default: function () {
                return {
                    online: [],
                    offline: []
                };
            }
        }
    },
    data () {
        return {
            tasks: [
                {
                    task: 'reboot',
                    name: 'reboot devices',
                    installer: true
                },
                {
                    task: 'update',
                    name: 'update devices',
                    installer: true
                },
                {
                    task: 'products',
                    name: 'configure product to all selected shops',
                    shops: true,
                    button: {
                        text: 'configure'
                    }
                },
                // {
                //     task: 'registercube',
                //     name: 'Re-register cubes to shop',
                //     button: {
                //         text: 'Register cube'
                //     }
                // },
                // {
                //     task: 'unregistercube',
                //     name: 'Unregister cube to shop',
                //     button: {
                //         text: 'Unregister cube'
                //     }
                // },
                {
                    task: 'update-enable',
                    name: 'enable updates',
                     task: 'envs',
                    name: 'configure settings to all selected shops',
                    shops: true,
                    button: {
                        text: 'configure'
                    }
                },
                // {
                //     task: 'disable-peripheral',
                //     name: 'Disable peripheral devices',
                //     button: {
                //         text: 'set'
                //     }
                // },
                // {
                //     task: 'enable-peripheral',
                //     name: 'Enable peripheral devices',
                //     button: {
                //         text: 'set'
                //     }
                // },
                // {
                //     task: 'unregistercube',
                //     name: 'Unregister cube from shop',
                //     button: {
                //         text: 'comission'
                //     }
                // },
            ],
            afterReboot: false,
            selectedTask: '',
            time: 0,
            duration: 5000,
            reinstall: {
                context: null,
                environment: 'test'
            },
            enviroments: [
                'test',
                'production'
            ],
            togo: '',
            shopsmodal: {
                disclamer: {
                    scrollable: true
                },
                listActions: {
                    scrollable: true
                }
            },
            selectedShop: null,
            noCloseModal: false,
            tasksGenerated: false,
            updatingClicked: false,
        }
    },
    computed: {
        ...mapGetters([ 'currentShop', 'currentSetup', "getShopList", "getUserId"])
    },
    methods: {
        ...mapActions([ 'createTaskAsync' ]),
        emitWithKey (method, data) {
            data.data.key = '8FD71A527448';
            data.state = '';
            this.$socket.client.emit(method, data);
        },
        selectedTaskButton (action){
            let text = 'commision';
            for(var i in this.tasks){
                if(this.tasks[i].task === action && this.tasks[i].button){
                    return this.tasks[i].button.text;
                }
            }

            return text;
        },
        actionVisible (action){
            if(action.task === "registercube" && (this.selectedShops.length > 0)){
              return false;
            }
            if(action.task === "unregistercube" && (this.selectedShops.length > 0)){
              return false;
            }

            if(action.cube && !this.cube){
                return false;
            }
            if(action.shops && !(this.selectedShops.length > 0)){
                return false;
            }
            if(this.cube && action.installer && !this.cube.installer){

                return false;
            }

            return true;
        },
        runAction: async function (action){
            if(this.updatingClicked){
                return;
            }
            if(this.selectedTask === 'products'){
                this.$router.push({name: 'productsbulk' });
            }
            if(this.selectedTask === 'envs'){
                this.$router.push({name: 'envsbulk' });
            }
            const { installation = { } } = this.currentSetup
            this.noCloseModal = false;
            if(this.cube){
                switch(this.selectedTask){
                    case 'reboot':
                        this.emitWithKey('restart', {cube: this.cube.name, data: {} });
                        break;
                    case 'update':
                        // this.emitWithKey('update-envs', { cube: this.cube.name, data: {...installation} });
                        //this.$modal.show('update-modal');
                        this.createTask({cube: this.cube.name});
                        this.noCloseModal = true;
                        this.updatingClicked = true;
                        break;
                    case 'reinstall':
                        this.emitWithKey('update-envs', { cube: this.cube.name, data: { reinstall: this.reinstall } });
                        break;
                    case 'registercube':
                      const env = `${process.env.VUE_APP_ENV}`;
                      const branch = `${process.env.VUE_APP_BRANCH}`;

                        this.createTask({cube: this.cube.name, toSend: { 
                          setupid: this.selectedShop,
                          environment: env,
                          branch: branch
                        }});
                        this.noCloseModal = true
                        try {
                            await Vue.axios.post('/collecter/classes/registercubeslogs', { cube: this.cube.name, setupid: this.selectedShop, env, userid: this.getUserId, data: { type: "registercube", "success": true} } ,{headers: {'X-Parse-Application-Id':'uGJEQnHj5DajteynrhvzAXnMH8'}});
                        } catch (error) {
                            console.error(error);
                        }
                        break;
                    case 'disable-peripheral':
                        this.emitWithKey('update-envs', { cube: this.cube.name, data: { disablePeripheral: true } });
                        break;
                    case 'enable-peripheral':
                        this.emitWithKey('update-envs', { cube: this.cube.name, data: { enablePeripheral: true} });
                        break;
                    case 'unregistercube':
                        this.emitWithKey('update-envs', { cube: this.cube.name, data: { unregisterCube: true } });
                        break;
                }
            } else if(this.cubes.length > 0){
                const contexts = this.cubes;
                if(this.selectedTask === 'update'){
                  this.createTask({cube: contexts});
                  this.noCloseModal = true;
                  this.updatingClicked = true;
                }
                for(var i in contexts){
                    const context = contexts[i];
                    switch(this.selectedTask){
                        case 'reboot':
                            this.emitWithKey('restart', {cube: context, data: {} });
                            break;
                        case 'update':
                            // this.emitWithKey('update-envs', { cube: context, data: {...installation} });
                            //this.$modal.show('update-modal');
                            break;
                        case 'reinstall':
                            this.emitWithKey('update-envs', { cube: context, data: { reinstall: this.reinstall } });
                            break;
                    }
                }
            } else {

                const contexts = [];
                for(var i in this.selectedShopsPart.online){
                    contexts.push(this.selectedShopsPart.online[i].id);
                }
                for(var i in this.selectedShopsPart.offline){
                    contexts.push(this.selectedShopsPart.offline[i].id);
                }
                if(this.selectedTask === 'update'){
                  this.createTask({contexts: contexts});
                  this.noCloseModal = true
                  this.updatingClicked = true;
                }
                for(var i in contexts){
                    const context = contexts[i];
                    switch(this.selectedTask){
                        case 'reboot':
                            this.emitWithKey('restart', {context: context, data: {} });
                            break;
                        case 'update':
                            // this.emitWithKey('update-envs', { context: context, data: {...installation} });
                            //this.$modal.show('update-modal');
                            break;
                        case 'reinstall':
                            this.emitWithKey('update-envs', { context: context, data: { reinstall: this.reinstall } });
                            break;
                    }
                }
            }
            if(!this.noCloseModal)
              this.$modal.hide('list-actions');
        },
        async createTask({cube = [], contexts = [], toSend = {}}){
          const {id} = await this.createTaskAsync({cubes: Array.isArray(cube) ? cube : [cube], contexts, userID: this.getUserId, toSend})
          this.tasksGenerated = true;
        },
        closeModal(){
            this.$modal.hide('list-actions');
            this.tasksGenerated = false;
            this.updatingClicked = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.label-input {
  float: none;
}
.panel{
   .panel-heading{
      min-height: 24px;
      padding-top: 3px;
      padding-bottom: 3px;
      h5{
        font-size: 24px;
        margin-bottom: 0;
        line-height: 30px;
      }
    }
    &.panel-success {
      color: #155724;
      background-color: #d4edda;
      border-color: #c3e6cb;
    }
    &.panel-warning {
      color: #856404;
      background-color: #fff3cd;
      border-color: #ffeeba;
    }

    &.actions {
      ul{
        list-style-type: none;
        padding-inline-start: 0;
      }
    }
  }
</style>
